window.adaptResidenceFilters = function(){
  if($('.js-city').val() == ""){
    $('[data-city]').show();
  }

  if($('.js-country').val() == ""){
    $('[data-country]').show();
  }

  if($('.js-country').val()){
    let pickedCountry = $('.js-country').val()

    $('[data-country]').hide();
    $(`[data-country="${pickedCountry}"]`).show();
  }

  if($('.js-city').val()){
    let pickedCity = $('.js-city').val()

    $('[data-city]').hide();
    $(`[data-city="${pickedCity}"]`).show();
  }
}